import { render, staticRenderFns } from "./NewCompanyModal.vue?vue&type=template&id=e2281310&scoped=true"
import script from "./NewCompanyModal.vue?vue&type=script&lang=js"
export * from "./NewCompanyModal.vue?vue&type=script&lang=js"
import style0 from "./NewCompanyModal.vue?vue&type=style&index=0&id=e2281310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2281310",
  null
  
)

export default component.exports